import React, { useState } from "react";
import { Link } from "react-router-dom";
import useBrandAsset from "@/lib/useBrandAsset";

export default function PublicFooter() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const submit = (e) => { e.preventDefault(); if (email) setDone(true); };
  const mascot = useBrandAsset("mascot.brand-ambassador", { fallback: "mascot.rocket" });
  return (
    <footer data-testid="public-footer" className="mt-24 border-t border-white/5 bg-black/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-2">
          <div className="flex items-center gap-2">
            {mascot.url && <img src={mascot.url} alt="Lifted" className="h-10 w-10" />}
            <span className="font-anton uppercase text-xl tracking-[0.18em]">LiftedAtTheMoment<span className="text-lifted-green text-xs align-top ml-0.5">™️🚀</span></span>
          </div>
          <p className="text-lifted-dim text-sm mt-4 max-w-md">A lifestyle brand. Capsule streetwear, premium accessories, same-day delivery, and the Lifted Affiliate Network. One brand. Unlimited possibilities.</p>
          <form onSubmit={submit} className="mt-6 flex gap-2 max-w-sm" data-testid="footer-email-form">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" className="input-lifted text-sm flex-1" data-testid="footer-email-input" />
            <button className="btn-lifted text-xs" data-testid="footer-email-submit">{done ? "Joined ✓" : "Subscribe"}</button>
          </form>
          <p className="text-[0.65rem] text-lifted-mute mt-2">Subscribe to our emails — be the first to know about new collections and exclusive offers.</p>
        </div>

        <div className="text-xs">
          <div className="eyebrow !text-lifted-text-dim mb-3">Shop</div>
          <ul className="space-y-2 text-lifted-dim">
            <li><Link to="/shop" className="hover:text-lifted-green">All collections</Link></li>
            <li><Link to="/collections/lifted-gear" className="hover:text-lifted-green">Lifted Gear</Link></li>
            <li><Link to="/collections/lifted-accessories" className="hover:text-lifted-green">Lifted Accessories</Link></li>
            <li><Link to="/lifted-monthly-box" className="hover:text-lifted-green" data-testid="footer-link-monthly-box">Lifted Monthly Box</Link></li>
            <li><Link to="/supplies" className="hover:text-lifted-green">Lifted Supplies</Link></li>
          </ul>
        </div>
        <div className="text-xs">
          <div className="eyebrow !text-lifted-text-dim mb-3">Discover</div>
          <ul className="space-y-2 text-lifted-dim">
            <li><Link to="/lifted-marketing" className="hover:text-lifted-green" data-testid="footer-link-marketing">Lifted Marketing</Link></li>
            <li><Link to="/lifted-views-news" className="hover:text-lifted-green" data-testid="footer-link-news">Lifted Views News</Link></li>
            <li><Link to="/affiliate-zone" className="hover:text-lifted-green">Affiliate Program</Link></li>
            <li><Link to="/products/lift-off-tier" className="hover:text-lifted-green">Join Lift-Off Tier</Link></li>
          </ul>
        </div>
        <div className="text-xs">
          <div className="eyebrow !text-lifted-text-dim mb-3">About</div>
          <ul className="space-y-2 text-lifted-dim">
            <li><Link to="/about" className="hover:text-lifted-green">About us</Link></li>
            <li><Link to="/contact" className="hover:text-lifted-green">Contact</Link></li>
            <li><Link to="/auth/login" className="hover:text-lifted-green">Sign in</Link></li>
            <li><Link to="/account" className="hover:text-lifted-green">Account</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 px-4 sm:px-6 lg:px-10 text-[0.65rem] text-lifted-mute flex flex-wrap justify-between gap-2 max-w-7xl mx-auto">
        <span>© {new Date().getFullYear()} LiftedAtTheMoment · A lifestyle brand</span>
        <span>21+ only · Age-verified at checkout & delivery</span>
      </div>
    </footer>
  );
}
